export default __webpack_public_path__ + "static/media/tab3_1.3f29ffa9.png";